var $b58a7d965b7aa1b3$exports = {};
$b58a7d965b7aa1b3$exports = {
    "loading": `Na\u{10D}\xedt\xe1n\xed...`,
    "loadingMore": `Na\u{10D}\xedt\xe1n\xed dal\u{161}\xedch...`
};


export {$b58a7d965b7aa1b3$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
